import axios from "axios";
import { BASE_URL } from "../../_constants/urlConstants";
import { delay, getUUID } from "../../_utils/generalUtils";
import raiseError from "../raiseError";
import qs from "qs";
import { QMS } from "../../_constants/actionConstants";
import { DOCTYPE } from "../../_constants/docTypeConstants";

const fakeIssue = {
  issueId: 1,
  divisionId: 1,
  issueNo: "SC-1",
  initiatedBy: 1,
  initiatedOn: new Date("1/1/23").toISOString(),
  isAcknowledged: true,
  acknowledgedOn: new Date("1/2/23").toISOString(),
  acknowledgedByQmsUserId: 2,
  isClosed: false,
  closedOn: null,
  closedByQmsUserId: null,
  isPaused: false,
  pausedOn: null,
  priority: "High",
  status: "Open",
  currentStage: 1,
  subject: "Revise BCM 1-1.01",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  qmsFrameworkChangeId: 1,
  followerQmsUserIds: [1, 2, 3],
  categoryIds: [1, 2],
  linkedQmsDocumentIds: [1, 2],
  issueStageSnippets: [
    {
      issueStageId: 1,
      cmtStageId: 1,
      ownerTeamId: 1,
      isCurrent: false,
      startedOn: new Date("2/1/2023").toISOString(),
      startedByQmsUserId: 1,
      isCompleted: true,
      completedOn: new Date("2/4/2023").toISOString(),
      duration: 3,
    },
    {
      issueStageId: 2,
      cmtStageId: 2,
      ownerTeamId: 1,
      isCurrent: true,
      startedOn: new Date("2/10/2023").toISOString(),
      startedByQmsUserId: 1,
      isCompleted: false,
      completedOn: null,
      duration: 40,
    },
  ],
};

const fakeIssueList = [
  {
    issueId: 1,
    divisionId: 1,
    issueNo: "SC-1",
    subject: "Revise BCM 1-1.01",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    priority: "High",
    initiatedOn: new Date("1/1/23").toISOString(),
    isAcknowledged: true,
    isPaused: false,
    isClosed: false,
    currentStageTitles: ["Stage A.1", "Stage A.2"],
    cmtCategoryIds: [1, 2],
    followerCount: 3,
  },
];

const logError = (e) => console.error("ProDMS/QMS: Request failed with error:", e);

const cmtIssueActions = {
  add: (newIssueData) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE.ADD });
    const apiEndpoint = BASE_URL + "/api/qms/Issue";
    // console.log("formData=", newIssueData);
    try {
      const res = await axios.post(apiEndpoint, newIssueData);
      dispatch({ type: QMS.ISSUE.ADD_FULFILLED });
      return true;
    } catch (e) {
      dispatch({ type: QMS.ISSUE.ADD_REJECTED });
      raiseError(QMS.ISSUE.ADD_REJECTED, e.response?.data);
      logError(e);
    }
  },
  acknowledge: (issueId) => async (dispatch, getState) => {
    dispatch({ type: QMS.ISSUE.UPDATE });
    const apiEndpoint = BASE_URL + "/api/qms/Issue/Acknowledge";
    try {
      const issue = getState().qms.openIssues[issueId] || null;
      const res = await axios.put(apiEndpoint, issue);
      dispatch({ type: QMS.ISSUE.UPDATE_FULFILLED, issueId, updatedIssue: res.data });
    } catch (e) {
      dispatch({ type: QMS.ISSUE.UPDATE_REJECTED });
      logError(e);
    }
  },

  open: (issueId) => async (dispatch, getState) => {
    dispatch({ type: QMS.ISSUE.UPDATE });
    const apiEndpoint = BASE_URL + "/api/qms/Issue/Open";
    try {
      const issue = getState().qms.openIssues[issueId] || null;
      const res = await axios.put(apiEndpoint, issue);
      dispatch({ type: QMS.ISSUE.UPDATE_FULFILLED, issueId, updatedIssue: res.data });
    } catch (e) {
      dispatch({ type: QMS.ISSUE.UPDATE_REJECTED });
      logError(e);
    }
  },
  close: (issueId) => async (dispatch, getState) => {
    dispatch({ type: QMS.ISSUE.UPDATE });
    const issue = getState().qms.openIssues[issueId] || null;
    if (!issue) return;
    const closedByQmsUserId = issue.closedByQmsUserId;
    const apiEndpoint = `${BASE_URL}/api/qms/Issue/Close/${issueId}/${closedByQmsUserId}`;
    try {
      const res = await axios.patch(apiEndpoint);
      dispatch({ type: QMS.ISSUE.UPDATE_FULFILLED, issueId, updatedIssue: res.data });
    } catch (e) {
      dispatch({ type: QMS.ISSUE.UPDATE_REJECTED });
      logError(e);
    }
  },
  update: (issueId) => async (dispatch, getState) => {
    dispatch({ type: QMS.ISSUE.UPDATE });
    const apiEndpoint = BASE_URL + "/api/qms/Issue";
    try {
      const issueData = getState().qms.openIssues[issueId] || null;
      const res = await axios.put(apiEndpoint, issueData);
      dispatch({ type: QMS.ISSUE.UPDATE_FULFILLED, issueId, updatedIssue: res.data });
    } catch (e) {
      dispatch({ type: QMS.ISSUE.UPDATE_REJECTED });
      logError(e);
    }
  },
  remove: (issueId) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE.REMOVE });
    const apiEndpoint = BASE_URL + "/api/qms/Issue/" + issueId;
    try {
      const res = await axios.delete(apiEndpoint);
      dispatch({ type: QMS.ISSUE.REMOVE_FULFILLED, cmtStages: res.data });
      console.log("remove done");
    } catch (e) {
      dispatch({ type: QMS.ISSUE.REMOVE_REJECTED });
      logError(e);
    }
  },
  get: (issueId) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE.FETCH });
    const apiEndpoint = BASE_URL + "/api/qms/Issue/" + issueId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({ type: QMS.ISSUE.FETCH_FULFILLED, issueId, issue: res.data });
    } catch (e) {
      dispatch({ type: QMS.ISSUE.FETCH_REJECTED });
      logError(e);
    }
  },
  getChildren: (divisionId, parentIssueId, tabId) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE.FETCH_CHILDREN });
    const apiEndpoint =
      BASE_URL + `/api/qms/Issue/List/ChildrenFor/${divisionId}/${parentIssueId}`;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.ISSUE.FETCH_CHILDREN_FULFILLED,
        tabId,
        issueId: parentIssueId,
        childIssueList: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.ISSUE.FETCH_CHILDREN_REJECTED });
      logError(e);
    }
  },
  reloadParent: (parentIssueId) => async (dispatch, getState) => {
    if (!(parentIssueId in getState().qms.openIssues)) return;
    dispatch({ type: QMS.ISSUE.FETCH });
    const apiEndpoint = BASE_URL + "/api/qms/Issue/" + parentIssueId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.ISSUE.FETCH_FULFILLED,
        issueId: parentIssueId,
        issue: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.ISSUE.FETCH_REJECTED });
      logError(e);
    }
  },
  getFake: (issueId) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE.FETCH });

    await delay(1000);
    dispatch({ type: QMS.ISSUE.FETCH_FULFILLED, issue: fakeIssue });
  },
  getAll: (divisionId) => async (dispatch, getState) => {
    dispatch({ type: QMS.ISSUE.FETCH_ALL });
    const cmtListTabIds = (getState().mainTabs.openTabs || [])
      .filter(
        (t) => "docType" in t && t.docType === DOCTYPE.QMS_CHANGE_MANAGEMENT_TRACKER_LIST
      )
      .map((t) => t.tabId);
    const apiEndpoint = BASE_URL + "/api/qms/Issue/List/" + divisionId;
    try {
      const res = await axios.get(apiEndpoint);
      (cmtListTabIds || []).forEach((tid) =>
        dispatch({ type: QMS.ISSUE.FETCH_ALL_FULFILLED, tabId: tid, issueList: res.data })
      );
    } catch (e) {
      dispatch({ type: QMS.ISSUE.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
  getAllFake: (tabId, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE.FETCH_ALL });
    delay(1200);
    dispatch({ type: QMS.ISSUE.FETCH_ALL_FULFILLED, tabId, issueList: fakeIssueList });
  },
  getNextNo: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.GENERIC_REQUEST });
    const apiEndpoint = BASE_URL + "/api/qms/Issue/NextIssueNo/" + divisionId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({ type: QMS.GENERIC_REQUEST_FULFILLED });
      return res.data;
    } catch (e) {
      dispatch({ type: QMS.GENERIC_REQUEST_REJECTED });
      logError(e);
    }
  },
  getCountOfOpen: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.GENERIC_REQUEST });
    const apiEndpoint = BASE_URL + "/api/qms/Issue/CountOfOpen/" + divisionId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({ type: QMS.GENERIC_REQUEST_FULFILLED });
      return res.data;
    } catch (e) {
      dispatch({ type: QMS.GENERIC_REQUEST_REJECTED });
      logError(e);
    }
  },
  getCountOfStale: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.GENERIC_REQUEST });
    const apiEndpoint = BASE_URL + "/api/qms/Issue/CountOfStale/" + divisionId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({ type: QMS.GENERIC_REQUEST_FULFILLED });
      return res.data;
    } catch (e) {
      dispatch({ type: QMS.GENERIC_REQUEST_REJECTED });
      logError(e);
    }
  },
  getCountOfNew: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.GENERIC_REQUEST });
    const apiEndpoint = BASE_URL + "/api/qms/Issue/CountOfNew/" + divisionId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({ type: QMS.GENERIC_REQUEST_FULFILLED });
      return res.data;
    } catch (e) {
      dispatch({ type: QMS.GENERIC_REQUEST_REJECTED });
      logError(e);
    }
  },
  downloadFile: (issueAttachmentId, filename) => async (dispatch) => {
    dispatch({ type: QMS.FILE_REQUEST });
    const apiEndpoint = BASE_URL + "/api/qms/Issue/File/" + issueAttachmentId;
    try {
      const res = await axios.get(apiEndpoint, {
        responseType: "blob",
      });
      if (res.data) {
        const fileBlob = new Blob([res.data]);

        const url = URL.createObjectURL(fileBlob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        dispatch({ type: QMS.FILE_REQUEST_FULFILLED });
      }
      return;
    } catch (err) {
      dispatch({ type: QMS.FILE_REQUEST_REJECTED });
      logError(err);
    }
  },
};

export default cmtIssueActions;
